import { Logout, UserMenu, UserMenuProps } from 'react-admin';

export const CustomUserMenu = (props: UserMenuProps) => (
  <UserMenu {...props}>
    <Logout />
  </UserMenu>
);
